// See https://animate.style/ for animate options
const candidates = document.querySelectorAll('.animate')
const options = {
  threshold: [0, 0.25, 0.5, 0.75, 1]
}
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    const objectHeight = entry.target.offsetHeight
    const windowHeight = window.innerHeight
    const ratio = parseFloat(entry.target.getAttribute('data-animate-ratio')) || 0.75 // use 1 to wait until object is fully in view
    if (
      entry.intersectionRatio >= ratio ||
      (objectHeight >= windowHeight && entry.isIntersecting) // If the oject is taller than the window, it may never meet the ratio requirement
    ) {
      const animationName = entry.target.getAttribute('data-animate-name') || 'fadeIn'
      entry.target.classList.add(animationName)
    }
  })
}, options)

candidates.forEach(el => {
  el.classList.add('animated')
  const speed = el.getAttribute('data-animate-duration') // e.g. '0.5s'
  const delay = el.getAttribute('data-animate-delay') // in seconds
  if (speed) { el.style.setProperty('animation-duration', speed) }
  if (delay) { el.style.setProperty('animation-delay', delay) }
  observer.observe(el)
})
